export const formatEstimatedDeliveryTime = (value: string): string => {
    const formattedDeliveryTime = Number(value);

    return `${value} Business ${formattedDeliveryTime === 1 ? 'day' : 'days'}`;
};
